module.exports = __webpack_public_path__ + "img/swap-right.632ad4d4.svg";